import { SvgIcon, SvgIconType } from "@/svg";
import clsx from "clsx";
import { Link } from "react-router";

type SimpleButtonProps = {
  icon: SvgIconType;
  label: string;
  imageSrc?: string;
  imageClassName?: string;
  isActive?: boolean;
  showChevron?: boolean;
  disabled?: boolean;
} & (
  | {
      href: string;
    }
  | {
      onClick: (e: React.MouseEvent) => void;
    }
);

export function SimpleButton({
  icon,
  label,
  imageSrc,
  imageClassName,
  isActive = false,
  showChevron = false,
  disabled = false,
  ...props
}: SimpleButtonProps) {
  const commonClassName = clsx(
    "flex items-center gap-2 font-medium transition-colors py-2 px-4 rounded-lg cursor-pointer",
    isActive
      ? "bg-backgroundGray text-dark"
      : "text-feintGray hover:text-dark hover:bg-backgroundGray",
  );

  if ("href" in props) {
    return (
      <Link
        to={props.href}
        title={label}
        className={clsx(commonClassName, disabled && "pointer-events-none")}
      >
        {imageSrc ? (
          <img src={imageSrc} alt={label} className={imageClassName} />
        ) : (
          <>
            <SvgIcon icon={icon} />
            <span className="max-w-[200px] truncate">{label}</span>
          </>
        )}
        {showChevron && <SvgIcon icon="ChevronDown" />}
      </Link>
    );
  }

  return (
    <button
      onClick={props.onClick}
      type="button"
      title={label}
      className={commonClassName}
      disabled={disabled}
    >
      {imageSrc ? (
        <img src={imageSrc} alt={label} className={imageClassName} />
      ) : (
        <>
          <SvgIcon icon={icon} />
          <span className="max-w-[200px] truncate">{label}</span>
        </>
      )}
      {showChevron && <SvgIcon icon="ChevronDown" />}
    </button>
  );
}
